var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "tw-flex tw-fixed tw-z-50 tw-w-screen tw-h-screen tw-justify-center tw-items-center",
        staticStyle: { background: "#00000075" }
      },
      [
        _c(
          "span",
          {
            staticClass:
              "tw-text-xl tw-font-semibold tw-text-white tw-uppercase"
          },
          [_vm._v(" loading... ")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }